<template>
  <div class="v-videos">
    <video-player
      v-if="source"
      :source="source"
      :type="type"
      @video-ended="onVideoEnded"
      @video-started="onVideoStart"
      ref="videoPlayer"
    />
    <video-slider
      :active-index="activeIndex"
      :status="status"
      :videos="videos"
      @index-updated="onIndexUpdated"
      @play="onPlay"
      @stop="onStop"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VideoPlayer from "@/components/VideoPlayer";
import VideoSlider from "@/components/VideoSlider";

export default {
  name: "v-videos",

  components: { VideoPlayer, VideoSlider },

  data() {
    return {
      activeIndex: 0,
      status: "stopped",
      source: null,
    };
  },

  computed: {
    ...mapGetters(["activePage"]),

    autoplay() {
      return this.activePage.autoplayVideos;
    },

    type() {
      if (!this.source) return null;
      const ext = this.source.split(".").pop();
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
        return "image";
      }
      if (["mov", "mp4", "webm"].includes(ext)) {
        return "video";
      }
      return null;
    },

    videos() {
      return this.activePage.videos;
    },
  },

  watch: {
    activeIndex() {
      this.playVideo();
    },

    videos() {
      this.init();
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.source = this.videos[0].asset.path;
      this.status = "stopped";

      setTimeout(() => {
        if (this.autoplay) {
          this.playVideo();
        }
      }, 1000);
    },

    onIndexUpdated(index) {
      this.activeIndex = index;
    },

    onPlay() {
      this.playVideo();
    },

    onStop() {
      this.stopVideo();
    },

    onVideoEnded() {
      this.status = "stopped";
      if (this.autoplay) {
        this.activeIndex++;
      }
    },

    onVideoStart() {
      this.status = "playing";
    },

    playVideo() {
      this.source = this.videos[this.activeIndex].asset.path;
      this.$refs.videoPlayer.play();
      this.$store.dispatch(
        "triggerVideo",
        this.videos[this.activeIndex].videowallVideoFilename
      );
    },

    stopVideo() {
      this.$refs.videoPlayer.stop();
      this.status = "stopped";
      this.$store.dispatch("triggerVideo", "default");
    },
  },
};
</script>
<style lang="scss">
.v-videos {
  height: 98rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 159.5rem;
  z-index: var(--modal-z-index);
}
</style>
